// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  signup: path(ROOTS_AUTH, '/signup'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  root: '/',
  jobs: '/jobs',
  companies: '/companies',
  company: (id: number | string) => `/companies/${id}`,
  salaryInsights: '/salary-insights',
  jobDetail: (id: number | string) => `/jobs/${id}`,
  // The original Job Victory contest, now one feature of the portal.
  contest: '/contest',
  quiz: '/quiz',
  contestRegister: '/contest/register',
  congratulation: '/congratulation',
  pricing: '/pricing',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  termsOfService: '/terms-of-service',
  refundPolicy: '/refund-policy',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  employer: {
    root: path(ROOTS_DASHBOARD, '/employer'),
    jobs: path(ROOTS_DASHBOARD, '/employer/jobs'),
    newJob: path(ROOTS_DASHBOARD, '/employer/jobs/new'),
    editJob: (id: number | string) => path(ROOTS_DASHBOARD, `/employer/jobs/${id}/edit`),
    jobApplicants: (id: number | string) =>
      path(ROOTS_DASHBOARD, `/employer/jobs/${id}/applicants`),
    applications: path(ROOTS_DASHBOARD, '/employer/applications'),
    messages: path(ROOTS_DASHBOARD, '/employer/messages'),
    profile: path(ROOTS_DASHBOARD, '/employer/profile'),
    candidates: path(ROOTS_DASHBOARD, '/employer/candidates'),
    pipeline: path(ROOTS_DASHBOARD, '/employer/pipeline'),
    interviews: path(ROOTS_DASHBOARD, '/employer/interviews'),
    billing: path(ROOTS_DASHBOARD, '/employer/billing'),
    aiManager: path(ROOTS_DASHBOARD, '/employer/ai'),
  },
  employee: {
    root: path(ROOTS_DASHBOARD, '/employee'),
    applications: path(ROOTS_DASHBOARD, '/employee/applications'),
    messages: path(ROOTS_DASHBOARD, '/employee/messages'),
    profile: path(ROOTS_DASHBOARD, '/employee/profile'),
    savedJobs: path(ROOTS_DASHBOARD, '/employee/saved-jobs'),
    matches: path(ROOTS_DASHBOARD, '/employee/job-matches'),
    interviews: path(ROOTS_DASHBOARD, '/employee/interviews'),
    resumeBuilder: path(ROOTS_DASHBOARD, '/employee/resume-builder'),
  },
  admin: {
    root: '/dashboard/admin',
    users: '/dashboard/admin/users',
    employers: '/dashboard/admin/employers',
    jobs: '/dashboard/admin/jobs',
    imports: '/dashboard/admin/imports',
    talent: '/dashboard/admin/candidate-database',
    categories: '/dashboard/admin/categories',
    payments: '/dashboard/admin/payments',
    reports: '/dashboard/admin/reports',
    settings: '/dashboard/admin/settings',
  },
};

export const dashboardFor = (role?: string) =>
  role === 'admin'
    ? PATH_DASHBOARD.admin.root
    : role === 'employer'
      ? PATH_DASHBOARD.employer.root
      : PATH_DASHBOARD.employee.root;
